/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Graphql from '@/services/Graphql'
import Logger from '@/services/Logger'
import sortBy from 'lodash/sortBy'
import { manageAttributesLabel } from '@/helpers/utils'

export default {
  openQuickBuy (ctx, obj) {
    let filter
    if (obj.url_key) {
      obj.url_key = obj.url_key.replace('.html', '').substr(obj.url_key.lastIndexOf('/') + 1)
    }
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        filter = {
          [key]: {
            eq: obj[key]
          }
        }
      }
    }
    return Graphql.genericCallCash({
      token: ctx.rootState.user.token,
      storeViewCode: ctx.rootState.ui.storeViewCode,
      graphSchemaType: 'graphProduct',
      variables: {
        filter
      }
    })
      .then(resp => {
        if (resp.data && resp.data.products && resp.data.products.items.length) {
          let product = resp.data.products.items.length ? resp.data.products.items[0] : {}
          // set link product
          if (product.attributesLabel.length) {
            product.attributesLabel = manageAttributesLabel(product.attributesLabel)
          }
          product.productLink = `/${ctx.rootState.ui.storeViewCode}/${product.url_key}${product.url_suffix}`
          // sort position media_gallery
          product.media_gallery = sortBy(product.media_gallery, ['position'])

          ctx.commit('setCurrentProduct', product)
          return product
        } else {
          Logger.error(resp)
          // eslint-disable-next-line
          throw { message: 'No product found' }
        }
      })
  },
  loadConfigurableByUrlKey (ctx, urlKey) {
    return Graphql.genericCall(
      {},
      ctx.rootState.user.token,
      ctx.rootState.ui.storeViewCode,
      'productConfigurable',
      {
        filter: {
          url_key: {
            eq: urlKey
          }
        }
      },
      false // cache false
    )
      .then(resp => {
        if (resp.data && resp.data.products) {
          let product = resp.data.products.items.length ? resp.data.products.items[0] : {}
          ctx.commit('updateCurrentVariant', product)
          return product
        } else {
          Logger.error(resp)
        }
      })
  },
  manageQuickView (ctx, product) {
    ctx.commit('setCurrentProduct', product)
    return ctx.commit('setToggle', true)
  }
}
